
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ContentActionsProviderAPI
 * @hideconstructor
 * @classdesc API class that is used to implement a content action provider for the purpose of contributing a content action
 */
define([
	'../utils/ObjectHelper'
], function(ObjectHelper) {

	class ContentActionsProviderAPI {

		/**
		 * @function ContentActionsProviderAPI#getContentActionList
		 * @description Returns a list of content actions available contents.
		 * @param {idList} idList
		 * @return {array} array containing all available actions
		 */
		getContentActionList() { }

	}

	/**
	 * @public
	 * @readonly
	 * @description	Available sections an action can be grouped in. The 'section' property can be defined in the content action specification.
	 * @enum {number}
	 * @memberof ContentActionsProviderAPI
	 */
	ContentActionsProviderAPI.ACTION_SECTION = ObjectHelper.deepFreezeObject({
		GLASS_APP: 100, // glass app actions
		DASHBOARD: 200, // dashboard/layout based actions
		SELECTION_DATA: 300, // selected visualization data/analyze based actions
		SELECTION_TEXT: 400, // selected text styling actions
		SELECTION_VIZ_FORMAT: 500, // selected visualization widget format actions
		SELECTION_WIDGET_FORMAT: 600, // selected common widget(s) format actions
		PANEL: 700 // panel actions
	});

	return ContentActionsProviderAPI;
});
